/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { AttachIcon, CloseIcon } from 'components/elements/Icons';
import { useDeviceDetect } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function Attachment({ onClick, text, isDisabled, classes, isNew, onDeleteFile }) {
  const styles = useStyles();
  const { isMobile } = useDeviceDetect();
  const maxLength = isMobile ? 10 : 20;
  const attachmentClasses = cn(styles.attachment, classes, { [styles.disabledAttachment]: isDisabled });
  const attachIconClasses = cn(styles.attachIcon, { [styles.disabledAttachIcon]: isDisabled });

  return (
    <button
      className={attachmentClasses}
      type="button"
      onClick={() => {
        if (!isDisabled && onClick) onClick();
      }}
    >
      <div className={attachIconClasses}>
        <AttachIcon />
      </div>
      <Typography className={styles.attachmentText} variant="caption" component="span">
        {text.length > 20 ? `${text.slice(0, maxLength)}...` : text}
      </Typography>
      {isNew && (
        <div className={styles.deleteFileButton} onClick={onDeleteFile}>
          <CloseIcon />
        </div>
      )}
    </button>
  );
}

Attachment.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  classes: PropTypes.string,
  isNew: PropTypes.bool,
  onDeleteFile: PropTypes.func,
};

Attachment.defaultProps = {
  isDisabled: false,
  classes: '',
  isNew: false,
  onClick: null,
  onDeleteFile: () => {},
};

export default Attachment;
